/* KBL article reading enhancements — builds the table of contents from the
   article body headings (progressive enhancement: no JS = article still reads
   fine, just no TOC). */
(function () {
  'use strict';

  function slugify(text) {
    var s = (text || '')
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
    return s.slice(0, 60) || 'section';
  }

  function init() {
    var content = document.querySelector('.kbl-reading');
    if (!content) return;

    var headings = content.querySelectorAll('h2, h3');
    var used = {};

    // Give every heading a stable, unique id + a scroll offset for the anchor.
    Array.prototype.forEach.call(headings, function (h) {
      if (!h.id) {
        var base = slugify(h.textContent);
        var id = base;
        var i = 2;
        while (document.getElementById(id) || used[id]) {
          id = base + '-' + i;
          i++;
        }
        h.id = id;
      }
      used[h.id] = true;
      if (!h.style.scrollMarginTop) h.style.scrollMarginTop = '90px';
    });

    var toc = document.querySelector('[data-kbl-toc]');
    if (!toc) return;

    var min = parseInt(toc.getAttribute('data-min') || '3', 10);
    if (headings.length < min) {
      toc.parentNode && toc.parentNode.removeChild(toc);
      return;
    }

    var list = toc.querySelector('.kbl-toc__list');
    if (!list) return;

    Array.prototype.forEach.call(headings, function (h) {
      var li = document.createElement('li');
      li.className = 'kbl-toc__item kbl-toc__item--' + h.tagName.toLowerCase();
      var a = document.createElement('a');
      a.className = 'kbl-toc__link';
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });

    // Open on desktop; keep collapsed on mobile.
    if (window.matchMedia && window.matchMedia('(min-width: 990px)').matches) {
      toc.open = true;
    }

    // On mobile, collapse after the reader taps a link.
    list.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('kbl-toc__link') && window.innerWidth < 750) {
        toc.open = false;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
